module.exports = {
    canDeleteDiscussion(projectId, project) {return gd.ac.check.project.fullAccess(projectId, project)},
    canRemoveUsers(projectId, project) {return gd.ac.check.project.fullAccess(projectId, project)},
};